var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "d-flex flex-column w-100 p-3 wrapper-package",
      class: [
        {
          "is-focus": _vm.isFocus
        }
      ]
    },
    [
      _c("div", { staticClass: "text-center" }, [
        _c("strong", { staticStyle: { "font-size": "24px" } }, [
          _c("i", {
            class: _vm.appIcon,
            style: "color: " + _vm.appColor + ";"
          }),
          _vm._v("\n      " + _vm._s(_vm.title) + "\n    ")
        ])
      ]),
      _vm._v(" "),
      _vm.isShowInfo
        ? _c("div", { staticClass: "d-flex flex-column" }, [
            _c(
              "div",
              [
                _c("BaseTable", {
                  staticClass: "custom-table",
                  attrs: { hidePagination: true, tableClass: "table-bordered" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "thead",
                        fn: function() {
                          return [
                            _c("thead", [
                              _c("tr", [
                                _c("th", { staticStyle: { width: "50%" } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("apps.billing.message.application")
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("th", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("apps.billing.message.module")
                                    )
                                  )
                                ])
                              ])
                            ])
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "tbody",
                        fn: function() {
                          return [
                            _c(
                              "tbody",
                              _vm._l(_vm.flattenedModules, function(
                                module,
                                index
                              ) {
                                return _c("tr", { key: module.uniqueKey }, [
                                  module.isFirst
                                    ? _c(
                                        "td",
                                        { attrs: { rowspan: module.rowspan } },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(module.appName) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(module.moduleName))])
                                ])
                              }),
                              0
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    2865920729
                  )
                }),
                _vm._v(" "),
                _vm.addOnTableRows.length
                  ? _c("BaseTable", {
                      staticClass: "custom-table mt-3",
                      attrs: {
                        hidePagination: true,
                        tableClass: "table-bordered"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "thead",
                            fn: function() {
                              return [
                                _c("thead", [
                                  _c("tr", [
                                    _c(
                                      "th",
                                      { staticStyle: { width: "50%" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("apps.billing.label.addon")
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("th", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("apps.billing.label.detail")
                                        )
                                      )
                                    ])
                                  ])
                                ])
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "tbody",
                            fn: function() {
                              return [
                                _c(
                                  "tbody",
                                  _vm._l(_vm.addOnTableRows, function(
                                    item,
                                    index
                                  ) {
                                    return _c("tr", { key: index }, [
                                      _c("td", [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(item.item) +
                                            "\n              "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(item.detail) +
                                            "\n              "
                                        )
                                      ])
                                    ])
                                  }),
                                  0
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        1601695082
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.advancedTableRows.length
                  ? _c("BaseTable", {
                      staticClass: "custom-table mt-3",
                      attrs: {
                        hidePagination: true,
                        tableClass: "table-bordered"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "thead",
                            fn: function() {
                              return [
                                _c("thead", [
                                  _c("tr", [
                                    _c(
                                      "th",
                                      { staticStyle: { width: "50%" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "apps.billing.label.advanced"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("th", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("apps.billing.label.detail")
                                        )
                                      )
                                    ])
                                  ])
                                ])
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "tbody",
                            fn: function() {
                              return [
                                _c(
                                  "tbody",
                                  _vm._l(_vm.advancedTableRows, function(
                                    item,
                                    index
                                  ) {
                                    return _c("tr", { key: index }, [
                                      _c("td", [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(item.item) +
                                            "\n              "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(item.detail) +
                                            "\n              "
                                        )
                                      ])
                                    ])
                                  }),
                                  0
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        3016939914
                      )
                    })
                  : _vm._e()
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "price-list" },
        _vm._l(_vm.priceList, function(priceListItem, index) {
          return _c("div", { key: index, staticClass: "price-list-item" }, [
            _c(
              "div",
              { staticClass: "switch" },
              [
                _c("vs-switch", {
                  staticStyle: { float: "left", margin: "0 10px 0 0" },
                  attrs: { color: "#A3CA76" },
                  on: {
                    change: function($event) {
                      return _vm.handleChangeSwitch(index)
                    }
                  },
                  model: {
                    value: priceListItem.is_active,
                    callback: function($$v) {
                      _vm.$set(priceListItem, "is_active", $$v)
                    },
                    expression: "priceListItem.is_active"
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "text d-flex" }, [
                  _c("div", [
                    _vm._v(
                      "\n            " +
                        _vm._s(priceListItem.label) +
                        "\n            "
                    ),
                    priceListItem.is_recommend
                      ? _c("span", [
                          _vm._v(
                            "\n              (" +
                              _vm._s(_vm.$t("apps.billing.message.bestsale")) +
                              ")\n            "
                          )
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  priceListItem.discount_amount > 0 && priceListItem.is_active
                    ? _c(
                        "span",
                        {
                          staticClass: "badge badge-danger ml-2",
                          staticStyle: {
                            height: "18px",
                            position: "relative",
                            top: "2px"
                          }
                        },
                        [
                          _c("i", { staticClass: "fas fa-tag" }),
                          _vm._v(
                            " " +
                              _vm._s(priceListItem.discount_percent) +
                              "%\n            -" +
                              _vm._s(
                                _vm
                                  .numeral(priceListItem.discount_amount)
                                  .format("0,0.[00]")
                              ) +
                              "\n          "
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "price" }, [
              priceListItem.is_active
                ? _c(
                    "div",
                    { staticClass: "d-flex", staticStyle: { gap: "10px" } },
                    [
                      priceListItem.discount_percent > 0
                        ? _c(
                            "span",
                            {
                              staticStyle: { "text-decoration": "line-through" }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm
                                      .numeral(priceListItem.sub_total)
                                      .format("0,0.[00]")
                                  ) +
                                  "\n          "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          "\n            +" +
                            _vm._s(
                              _vm
                                .numeral(priceListItem.total)
                                .format("0,0.[00]")
                            ) +
                            " THB\n          "
                        )
                      ])
                    ]
                  )
                : _vm._e()
            ])
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "text-right d-flex justify-content-between align-items-center",
          staticStyle: {
            "border-top": "solid #d8e2e7 1px",
            "padding-top": "15px",
            gap: "5px"
          }
        },
        [
          _c(
            "a",
            {
              attrs: {
                href: "https://treesoft.io/th/pricing",
                target: "_blank"
              }
            },
            [
              _vm._v("\n      " + _vm._s(_vm.$t("message.price")) + "\n      "),
              _c("i", { staticClass: "fas fa-external-link-alt" })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _vm.isShowBackHomeButton
                ? _c(
                    "BaseButton",
                    {
                      staticStyle: { "font-size": "16px" },
                      attrs: {
                        disabled: _vm.isSubmitted,
                        className: "btn-lg btn-light"
                      },
                      on: { click: _vm.handleClickClose }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("button.close")) +
                          "\n      "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "BaseButton",
                {
                  class: [_vm.payButtonClass],
                  staticStyle: { "font-size": "16px" },
                  attrs: { disabled: _vm.isSubmitted, className: "btn-lg" },
                  on: { click: _vm.handleClickPayButton }
                },
                [
                  _vm.isSubmitted
                    ? _c("span", [
                        _c("i", { staticClass: "fas fa-spinner spin" })
                      ])
                    : _c("span", [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.payButtonText) +
                            "\n          "
                        ),
                        _c("i", { staticClass: "fas fa-cloud-upload-alt" })
                      ])
                ]
              )
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b626198", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b626198","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom/Package.vue
// module id = null
// module chunks = 